import { IColunasSettingsUser } from '@app/shared/utils/validar_settings_user';

export const COLUNAS_DEFAULT_MODULE_VENDAS = [
  {
    module: 'VEN_CAIXA',
    colunas: [
      {
        active: true,
        removable: false,
        field: 'numero'
      },
      {
        active: true,
        removable: false,
        field: 'terminal.descricao'
      },
      {
        active: true,
        removable: true,
        field: 'created_by_user.name'
      },
      {
        active: true,
        removable: true,
        field: 'created_at'
      },
      {
        active: true,
        removable: true,
        field: 'status_dh'
      },
      {
        active: true,
        removable: true,
        field: 'valor_total'
      },
      {
        active: true,
        removable: true,
        field: 'status'
      }
    ]
  },
  {
    module: 'VEN_PEDIDO',
    colunas: [
      { field: 'numero', active: true, removable: true },
      {
        field: 'cliente.parceiro.nome_razao_social',
        active: true,
        removable: false
      },
      {
        field: 'vendedor.parceiro.nome_razao_social',
        active: true,
        removable: false
      },
      { field: 'condicao_pagamento.descricao', active: true, removable: true },
      { field: 'valor_total', active: true, removable: true },
      { field: 'created_at', active: true, removable: true },
      { field: 'status', active: true, removable: true },
      { field: 'tem_nfe', active: true, removable: false }
    ]
  },
  {
    module: 'VEN_PRE_PEDIDO',
    colunas: [
      { field: 'numero', active: true, removable: true },
      { field: 'tipo', active: true, removable: true },
      {
        field: 'vendedor.parceiro.nome_razao_social',
        active: true,
        removable: true
      },
      {
        field: 'cliente.parceiro.nome_razao_social',
        active: true,
        removable: false
      },
      { field: 'created_at', active: true, removable: true },
      { field: 'status', active: true, removable: true }
    ]
  },
  {
    module: 'VEN_PEDIDO_INTEGRACAO',
    colunas: [
      { field: 'numero', active: true, removable: true },
      {
        field: 'payload.cliente.parceiro.nome_razao_social',
        active: true,
        removable: false
      },
      {
        field: 'vendedor.parceiro.nome_razao_social',
        active: true,
        removable: true
      },
      {
        field: 'payload.condicao_pagamento.descricao',
        active: true,
        removable: true
      },
      { field: 'status', active: true, removable: true },
      { field: 'payload.valor_total', active: true, removable: true }
    ]
  }
] as IColunasSettingsUser[];
